import TextField from "@mui/material/TextField/TextField";
import { Dispatch, Ref, SetStateAction } from "react";
import InputMask from "react-input-mask";

interface MaskedTextFieldProps {
  label: string;
  value?: string;
  setValue?: Dispatch<SetStateAction<string>>;
  mask: string;
  maskChar: string;
  error?: boolean;
  helperText?: string;
  inputRef?: Ref<HTMLInputElement>;
  defaultValue?: string;
}

const MaskedTextField = (props: MaskedTextFieldProps) => {
  const {
    label,
    value,
    setValue,
    mask,
    maskChar,
    error,
    helperText,
    inputRef,
    defaultValue,
  } = props;

  return (
    <InputMask
      mask={mask}
      disabled={false}
      maskChar={maskChar}
      inputRef={inputRef}
      value={value}
      onChange={(e) => setValue(e.target.value)}
    >
      <TextField
        size="small"
        fullWidth
        label={label}
        error={error}
        helperText={helperText}
        defaultValue={defaultValue}
      />
    </InputMask>
  );
};

export default MaskedTextField;
